import { Button, Conditional } from "@result/rui/components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const NotAuthorized = ({
  showBackButton = true,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="is-flex is-justify-content-center p-4">
      <div className="is-flex is-align-items-center is-flex-wrap is-gap-3">
        <Conditional condition={showBackButton}>
          <Button
            label={t("common.back")}
            leftIcon="icon-chevron-left"
            onClick={() => navigate("/pokk")}
          />
        </Conditional>
        <div className="notification is-danger mb-0">
          <i className="icon icon-circle-exclamation has-text-danger is-size-4 mr-3" />
          {t("authorization.noAccess")}
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;
